<script setup>
import { ref, watch } from 'vue'
import { CAMPAIGN_CONFIG, IS_STAGING } from './config.js'
import { useMysterySoundGuessStore } from './stores/mysterySoundGuess'
import { useLastVoteStore } from './stores/lastVote'
import Expired from './components/Expired.vue'
import VoteGuess from './components/VoteGuess.vue'
import Voted from './components/Voted.vue'
import AlreadyVoted from './components/AlreadyVoted.vue'
import VoteCorrect from './components/VoteCorrect.vue'
import VoteIncorrect from './components/VoteIncorrect.vue'

const commitHash = import.meta.env.VITE_COMMIT_HASH || 'dev'

const mysterySoundGuess = useMysterySoundGuessStore()
mysterySoundGuess.initilize()

const lastVote = useLastVoteStore()
lastVote.initilize()

const STATES = {
  VOTE: 'vote',
  VOTED: 'voted',
  VOTE_CORRECT: 'vote_correct',
  VOTE_INCORRECT: 'vote_incorrect',

  EXPIRED: 'expired',
  ALREADY_VOTED: 'already_voted',
}

const state = ref(STATES.VOTE)

watch(
  () => [lastVote.votedOnActiveGuess, mysterySoundGuess.correct, lastVote.alreadyVoted, mysterySoundGuess.isExpired],
  ([votedOnActiveGuess, correct, alreadyVoted, isExpired]) => {
    if (votedOnActiveGuess) {
      if (correct === true) {
        state.value = STATES.VOTE_CORRECT
      } else if (correct === false) {
        state.value = STATES.VOTE_INCORRECT
      } else {
        state.value = STATES.VOTED
      }
    } else if (alreadyVoted) {
      state.value = STATES.ALREADY_VOTED
    } else if (isExpired) {
      state.value = STATES.EXPIRED
    } else {
      state.value = STATES.VOTE
    }
  },
  { immediate: true }
)

const reloadPage = () => {
  window.location.reload()
}

const clearVote = () => {
  localStorage.removeItem('last_vote')
  lastVote.$reset()
  alert('Cleared!')
}
</script>

<template>
  <component :is="CAMPAIGN_CONFIG.component" v-slot="{ contentClass }">
    <Transition
      appear
      mode="out-in"
      enterActiveClass="transition-opacity duration-400"
      leaveActiveClass="transition-opacity duration-400"
      enterFromClass="opacity-0"
      enterToClass="opacity-100"
      leaveFromClass="opacity-100"
      leaveToClass="opacity-0"
    >
      <component
        :is="
          {
            [STATES.VOTE]: VoteGuess,
            [STATES.VOTED]: Voted,
            [STATES.VOTE_CORRECT]: VoteCorrect,
            [STATES.VOTE_INCORRECT]: VoteIncorrect,
            [STATES.EXPIRED]: Expired,
            [STATES.ALREADY_VOTED]: AlreadyVoted,
          }[state]
        "
        ref="component"
        :key="state"
        v-bind="state === STATES.VOTE ? { questionClass: contentClass } : { class: contentClass }"
        :data-testid="
          {
            [STATES.VOTE]: 'state-vote',
            [STATES.VOTED]: 'state-voted',
            [STATES.VOTE_CORRECT]: 'state-correct',
            [STATES.VOTE_INCORRECT]: 'state-incorrect',
            [STATES.EXPIRED]: 'state-expired',
            [STATES.ALREADY_VOTED]: 'state-already-voted',
          }[state]
        "
      />
    </Transition>
  </component>

  <div v-if="IS_STAGING" style="font-family: monospace; font-size: 11px; color: #999; text-align: center; padding: 8px">
    staging: {{ commitHash }} | <a href="#" @click.prevent="clearVote">clear vote</a> |
    <a href="#" @click.prevent="reloadPage">reload</a>
  </div>
</template>
